import * as React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';

const getVariantClasses = variant => {
  const baseClasses =
    'inline-flex items-center rounded-2xl px-5 py-0.5 text-lg font-semibold transition-colors focus:outline-none';

  const variantMap = {
    default: 'border-transparent bg-primary-4/10 text-primary-5',
    secondary: 'border-transparent bg-surface-secondary text-text-secondary',
    outline: 'border-border-primary text-text-primary bg-white',
    success: 'border-transparent bg-green-10 text-green-150',
    warning: 'border-transparent bg-orange-20 text-orange-3',
    error: 'border-transparent bg-red-20 text-red-150',
  };

  return cn(baseClasses, variantMap[variant] || variantMap.default);
};

export const Badge = ({ text, className, variant, ...props }) => {
  return (
    <div className={cn(getVariantClasses(variant), className)} {...props}>
      {text}
    </div>
  );
};

Badge.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'secondary', 'outline', 'success', 'warning', 'error']),
};
